import styled from "@emotion/styled";
import { COLORS } from "../../shared/theme";

export const Input = styled.input<{ withResetButton?: boolean }>`
  width: 100%;
  height: 45px;
  padding: 0 10px;
  font: 400 20px/25px SF Pro;
  border-radius: 10px;
  border: 2px solid ${COLORS.BORDER};
  color: ${COLORS.BLACK};

  &::placeholder {
    font-weight: 400;
    color: ${COLORS.SILVER};
  }
  &:focus {
    border-color: ${COLORS.BLACK};
    outline: none;
  }
`;
